// extracted by mini-css-extract-plugin
export var dividerContainer = "_5j-0";
export var line = "_5j-1";